import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { HeaderComponent } from './components/common/header/header.component';
import { SharedModule } from './components/shared/shared.module';
import {HomeComponent} from "./components/pages/home/home.component";
import {AboutComponent} from "./components/pages/about-us/about-us.component";
import {ServicesComponent} from "./components/pages/services/services.component";
import {ProductsGrcComponent} from "./components/pages/products-grc/products-grc.component";
import {
  ProductsPhishingSimulationComponent
} from "./components/pages/products-phishing-simulation/products-phishing-simulation.component";
import {ProductsPhishingComponent} from "./components/pages/products-phishing/products-phishing.component";
import {BlogsComponent} from "./components/pages/blogs/blogs.component";
import {BlogsDetailsComponent} from "./components/pages/blogs-details/blogs-details.component";
import {ContactUsComponent} from "./components/pages/contact-us/contact-us.component";
import { MatIconModule } from "@angular/material/icon";
import {HttpClientModule} from "@angular/common/http";
import { L10nTranslationModule, L10nIntlModule } from 'angular-l10n';
import { l10nConfig } from './l10n-config';
import { PartnerComponent } from './components/pages/partner/partner.component'
import {MatMenuModule} from '@angular/material/menu';
import {TermsComponent} from "./components/pages/terms/terms.component";
import { CookiesComponent } from './components/pages/cookies/cookies.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './components/pages/cookie-policy/cookie-policy.component';
import {NguCarouselModule} from "@ngu/carousel";
import { ReactiveFormsModule } from '@angular/forms';
import { AwarenessPostersComponent } from './components/pages/awareness-posters/awareness-posters.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    AboutComponent,
    ServicesComponent,
    ProductsGrcComponent,
    ProductsPhishingSimulationComponent,
    ProductsPhishingComponent,
    BlogsComponent,
    BlogsDetailsComponent,
    ContactUsComponent,
    PartnerComponent,
    TermsComponent,
    CookiesComponent,
    PrivacyPolicyComponent,
    CookiePolicyComponent,
    AwarenessPostersComponent
  ],
  imports: [
    BrowserAnimationsModule,
    NguCarouselModule,
    BrowserModule,
    SharedModule,
    AppRoutingModule,
    MatIconModule,
    HttpClientModule,
    L10nTranslationModule.forRoot(l10nConfig),
    L10nIntlModule,
    MatMenuModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
